import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { Card, Col, Row, Form, Button, Spinner } from 'react-bootstrap';
import { useGetDta } from '../../hooks/useGetDta';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';
import MenuPerzonalizado from './MenuPerzonalizado';
import ShowPortal from './ShowPortal';
const opciones = [
    {
        url: 'https://getwallpapers.com/wallpaper/full/8/3/e/198252.jpg',
        value: 'fondo1',
        label: 'fondo1',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/full/f/7/d/198407.jpg',
        value: 'fondo2',
        label: 'fondo2',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/full/9/5/9/198298.jpg',
        value: 'fondo3',
        label: 'fondo3',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/full/7/0/7/198309.jpg',
        value: 'fondo4',
        label: 'fondo4',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/small-retina/a/6/c/35748.jpg',
        value: 'fondo5',
        label: 'fondo5',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/full/b/f/8/43539.jpg',
        value: 'fondo6',
        label: 'fondo6',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/full/2/7/1/476168.jpg',
        value: 'fondo7',
        label: 'fondo7',
    },
    {
        url: 'https://getwallpapers.com/wallpaper/full/c/6/6/43587.jpg',
        value: 'fondo8',
        label: 'fondo8',
    },
];

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
        transition: 'background-color 0.3s, color 0.3s', // Agregamos transición para el efecto hover
        '&:hover': {
            backgroundColor: '#f0f0f0', // Cambiar el color de fondo al pasar el ratón
            color: '#333', // Cambiar el color del texto al pasar el ratón
        },
    }),
    // Puedes agregar estilos personalizados si lo necesitas
};
const PortalGneral = () => {
    const { loading, data } = useGetDta('main/portal/portal');
    const [validated, setValidated] = useState(false);
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);

    const [placeholder, setPlaceholder] = useState('');
    const handleOptionMouseOver = (option) => setPlaceholder(option.url);
    const [values, handleInputChange, setFormValue] = useForm({
        id: '',
        titulo_portal: '',
        url_portal: '',
        imagen_portal: '',
    });
    useEffect(() => {
        if (data.id) {
            setPlaceholder(data.imagen_portal);

            setFormValue({ ...values, ...data });
        }
    }, [data]);
    const handleOptionSelect = (option) => {
        setPlaceholder(option.url);
        setFormValue({ ...values, imagen_portal: option.url });
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`main/portal`, { id: values.id, items: { ...values } }, 'POST');
            setResp(res);
        }
        setLoad(false);
    };
    if (loading) return <LoadinSpin />;

    return (
        <div className="p-2">
            <Row>
                <Col>
                    {' '}
                    <Card>
                        <Card.Header>Datos del portal</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <Form noValidate validated={validated} onSubmit={onSubmit}>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-2" controlId="validationCusto">
                                            <Form.Label>Titulo del portal</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.titulo_portal}
                                                name="titulo_portal"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-2" controlId="validationCusto">
                                            <Form.Label>Url portal </Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.url_portal}
                                                name="url_portal"
                                                onChange={handleInputChange}
                                            />{' '}
                                            <small className="text-danger">
                                                Debe colocar la IP o dominio correcto ya que este tambien será utilizado
                                                para mostrar los avisos. Ejm: http://192.168.2.2 o https://dominio.net
                                            </small>
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>

                                    <Col xl="auto">
                                        <Form.Group className="mb-2" controlId="validationCusto">
                                            <Form.Label>Seleccionar un fondo</Form.Label>
                                            <Select
                                                options={opciones.map((opcion) => ({
                                                    ...opcion,
                                                    label: (
                                                        <div
                                                            onMouseOver={() => handleOptionMouseOver(opcion)}
                                                            onMouseOut={() => setPlaceholder('Seleccionar un fondo')}>
                                                            <img
                                                                src={opcion.url}
                                                                alt={opcion.label}
                                                                style={{
                                                                    width: '100%',
                                                                    height: '250px',
                                                                    marginRight: '5px',
                                                                }}
                                                            />
                                                        </div>
                                                    ),
                                                }))}
                                                className={`${!placeholder && 'app-search dropdown'}`}
                                                classNamePrefix="react-select"
                                                placeholder={placeholder}
                                                onChange={handleOptionSelect}
                                                styles={customStyles}
                                                isSearchable={false}
                                            />{' '}
                                        </Form.Group>
                                        <Col className="p-3">
                                            {data.imagen_portal && (
                                                <img src={data.imagen_portal} alt="Imagen" style={{ width: '340px' }} />
                                            )}
                                        </Col>
                                    </Col>
                                    {load ? (
                                        <Button color="primary" disabled>
                                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                            Guardando...
                                        </Button>
                                    ) : (
                                        <Button type="submit">Guardar</Button>
                                    )}
                                </Form>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col>
                    <MenuPerzonalizado />
                </Col>
                <Col>
                    <ShowPortal />
                </Col>
            </Row>
        </div>
    );
};

export default PortalGneral;
